const Environment = {};
const getEnvironment = (state = Environment, action) => {
    if(action.type === "GET_ENVIRONMENT"){
        state   = action.envData
    }
    return state;
}

export default getEnvironment;